import React from 'react';
import { HelpCircle } from 'lucide-react';
import { S } from '../../lib/constants';
import GlossaryItem from '../shared/GlossaryItem';

export default function GlossarySection() {
  return (
    <div style={S.card}>
      <div className="p-5">
        <h3 className="font-semibold mb-4 flex items-center gap-2" style={{ color: '#2563EB' }}><HelpCircle className="w-5 h-5" />Glossary</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 text-sm">
          <GlossaryItem term="Mining Multiplier" color="gold" def="BTC value mined ÷ total costs. Above 1× means mining beats spot purchase." />
          <GlossaryItem term="Break-Even" color="purple" def="First month where NAV exceeds total invested capital." />
          <GlossaryItem term="Treasury" color="gold" def="Total BTC holdings = Starting + BTC Kept each month." />
          <GlossaryItem term="NAV" color="blue" def="Net Asset Value = (Treasury × BTC Price) + Cash." />
          <GlossaryItem term="ROI" color="green" def="Return = ((NAV - Capital Deployed) / Capital Deployed) × 100%." />
          <GlossaryItem term="Sunk Cost" color="purple" def="Initial fleet CapEx treated as already paid, so it is excluded from the ROI denominator." />
          <GlossaryItem term="Cash" color="green" def="Running balance: +revenue +loans +resale -capex -opex." />
          <GlossaryItem term="Difficulty Growth" color="blue" def="Monthly growth of network difficulty (~0.8%/mo = ~10%/yr). Higher difficulty = less BTC mined." />
        </div>
      </div>
    </div>
  );
}
